import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./CertifiedInstructors.module.scss";

interface CertifiedInstructorsProps { }

const CertifiedInstructors: React.FC<CertifiedInstructorsProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { instructors } = data?.bookConsultation?.whatHappensNext || {};

  if (!instructors) {
    return <></>
  }


  return (
    <div className={cls("instructorsContainer")}>
      <div className={cls("instructorsWrapper")}>
        <div className={cls("instructors")}>
          {instructors?.instructors?.map(({ profilePicture }, index) => (
            <Image
              key={index}
              className={cls("instructor")}
              src={profilePicture}
              alt="instructor"
            />
          ))}
        </div>
      </div>
      <div className={cls("content")}>
        <Typography variant="heading6" className={cls("title")}>
          {instructors?.title}
        </Typography>
        <Typography variant="paragraph1" className={cls("description")}>
          {instructors?.description}
        </Typography>
      </div>
    </div>
  );
};

export default CertifiedInstructors;
